const LoginView = () => import("@/views/LoginView.vue");
import {RouteEnum} from "@/router/RouteEnum.ts";

const login = {
  path: '/login',
  name: RouteEnum.Login,
  component: LoginView,
}
const azureCheck = {
  path: '/connect/azure/check',
  name: RouteEnum.AzureCheck,
  component: LoginView
}

const authCallback = {
  path: '/auth/callback',
  name: RouteEnum.AuthCallback,
  component: LoginView
}

const accountRoutes = [login, azureCheck, authCallback]
export default accountRoutes
